import React from 'react';
import ProjectTemplate from '../components/ProjectTemplate';

const Medusa_IIPage = () => {

  return (
    <div className="medusa-page">
      
 <ProjectTemplate
title="medusa II"
year="2022"
  sections={[
    {
      type: 'description',
      text: 'In medusa II I continue an experimentation I began with the installation medusa. In medusa II, the new iteration of the installation, which is based on the same chaotic principle, the aquarium contains a similar setup; the pumps and the cloth are still present. The relays, TL lights and strobes however, have been removed. Instead, a metal beam with a motorised cart is placed above and in the length of the aquarium. The cart has a red cross-laser attached to it, which points towards the bottom of the aquarium. Here, sensors are placed to detect the laser and more importantly, to detect when the laser is obstructed by the cloth. The sensors lead to a microcontroller (arduino) which controls the motorised cart. The programme on the arduino "scans" for the cloth and if it detects it, the cart will slow down. When it "loses" the cloth it will scan again, and so forth. The movement of the cart is thus based on the chaotic movement of the cloth. The laser light is the only light in the installation (and in the room), which is made dimly visible through ink and dirt in the water. When this light hits the dynamically moving cloth, however, playfully swirling red lines can be seen. The rest of the room is in total darkness, also hiding the pumps and even the aquarium itself. The focus should be on the behaviour of the moving laser, influenced by the behaviour of the cloth, and the resulting visual patterns. In the previous iteration of this work, the cloth was more or less constantly visible, here, the "invisibility" of the cloth (and the pumps) is vital to the work. We only see what the laser "sees".'
    },
    {
      type: 'video',
      links: ['https://www.youtube.com/embed/phCtgwJO38k?si=B4jCd6VccX5Pz0Hw?controls=1&modestbranding=1&rel=0&showinfo=0']
    }, 
    {
      type: "description",
      text: 'Another iteration consisted of 16 point lasers with respective light sensors on opposite sides. In this version a chord is being played where the amount the cloth is blocking the the lasers is mapped to the volume of different sine wave frequencies.'
    },
    {
        type: 'video',
        links: ['https://www.youtube.com/embed/aj_pkYV_LBI?si=QmNtOrT6XOt4wUQD?controls=1&modestbranding=1&rel=0&showinfo=0']
    }
  ]}
  
/>

    </div>
  );
};

export default Medusa_IIPage;
